/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {recommendSupportArticles} from '../api'

export const useMutationRecommendSupportArticles = createReactQueryMutationHook('recommendSupportArticles', recommendSupportArticles)
